export enum UtilityServiceConstants {
  GAS = 'Gas',
  ELECTRICITY = 'Electricity',
  WATER = 'Water',
  SEWER = 'Sewer'
}

export const billWithNoDemand = [
  UtilityServiceConstants.GAS,
  UtilityServiceConstants.WATER,
  UtilityServiceConstants.SEWER
];

export enum ApiMessages {
  BILLALREADYEXISTS = 'Bill already exists for the selected billing period',
  BILLPROCESSINGINPROGRESS = 'Bill Processing is still in progress. Please try after some time',
  BILLSAVED = 'Bill saved successfully',
  ERRORPROCESSING = 'Error While processing the bill'
}
